import DropboxChooser from "react-dropbox-chooser";
import { DropBoxAppKey } from "../../constants";
import { useEffect } from "react";

function ChooseFile({
  onDropboxSuccess,
  clearFieldError,
  dropboxRef,
  chooserOpen,
  setChooserOpen,
  // authorizationDropboxToken,
}) {
  const authorizationDropboxToken = sessionStorage.getItem(
    "authorizationDropboxToken"
  );
  useEffect(() => {
    if (authorizationDropboxToken && dropboxRef.current && chooserOpen) {
      setTimeout(() => {
        dropboxRef.current.click();
      }, 1800);
    }
  }, [authorizationDropboxToken]);

  return (
    <DropboxChooser
      appKey={DropBoxAppKey}
      success={(file) => onDropboxSuccess(file)}
      cancel={() => setChooserOpen(false)}
      // cancel={() => sessionStorage.removeItem('authorizationDropboxToken')}
      multiselect={false}
      style={{ marginBottom: "139px" }}
      extensions={[".ogm", ".ogv", ".ogg", ".mp4", ".webm", ".mpeg"]}
      folderselect={false}
      // ref={dropboxRef}
    >
      <div
        ref={dropboxRef}
        id="DropBoxpickerdiv"
        className="uploadBtn dropbox"
        onClick={clearFieldError}
      >
        Upload video from Dropbox
        {/* <div className="dropbox"> </div> */}
      </div>
    </DropboxChooser>
  );
}

export default ChooseFile;
